// @flow

import * as React from 'react';
import classNames from 'classnames';
import useSheet from '../../jss';

type Props = {
  children?: any,
  noWhiteSpace?: boolean,
  classes: Object,
  textAlign?: string,
  className?: string,
  ellipsis?: boolean
};

const defaultProps = {
  children: undefined,
  noWhiteSpace: false,
  textAlign: 'center',
  className: undefined,
  ellipsis: false
};

function Title({ children, noWhiteSpace, ellipsis, classes, textAlign, className }: Props) {
  return (
    <div
      className={classNames(classes.title, { spaced: !noWhiteSpace, ellipsis }, className)}
      style={{ textAlign }}
    >
      {children}
    </div>
  );
}

Title.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    title: {
      fontWeight: theme.fontWeight.bold,
      fontSize: theme.fontSize.large,
      margin: 0,
      textTransform: 'uppercase',
      '&.spaced': {
        marginTop: theme.spacing.large,
        marginBottom: theme.spacing.small
      },
      '&.ellipsis': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }
  };
}

export default useSheet(applyStyles)(Title);
